module.exports = __webpack_public_path__ + "media/images/lb/995-f065eb61c65cbb770fa8ed76375464e6.svg";